<template>
  <div class="nav-app">
        <navbar>
      <a class="navbar-brand" slot="brand" href="#">
        <img alt="Brand" style="height: 100%; width: auto" src="../assets/logo.png">
        </a>
      <template slot="collapse">
        <navbar-nav ref="navLeft">
          <li v-for="(item, index) in routes" :key="index" :class="{'active' : $route.path === item.path}">
            <router-link :to="{path:item.path}" :class="{'active' : $route.path === item.path}">
            {{item.title}}
            </router-link>
          </li>
          <dropdown tag="li">
            <a class="dropdown-toggle" role="button">更多 <span class="caret"></span></a>
            <template slot="dropdown">
              <li><a role="button" @click="go('/order-brands')">品牌管理</a></li>
              <li><a role="button" @click="go('/order-colors')">颜色管理</a></li>
              <li><a role="button" @click="go('/order-flaws')">瑕疵管理</a></li>
              <li><a role="button" @click="go('/order-prices')">价格管理</a></li>
              <li role="separator" class="divider"></li>
              <li><a role="button">未洗衣物</a></li>
              <li><a role="button">数据报表</a></li>
            </template>
          </dropdown>
        </navbar-nav>
        <navbar-form left>
          <div class="form-group">
            <div class="col-sm-10">
            <input :style="{width: !isMobile ?  searchWidth: false}" v-model="searchKey" id="input" type="text" class="form-control" placeholder="手机号、会员卡号、姓名" @input="onSearchKeyChaged">
            </div>
          </div>
        </navbar-form>
        <navbar-nav ref="navRight" right>
          <li>
            <a role="button" @click="reload">
              刷新
            </a>
          </li>
          <li>
            <a role="button" id="btn-message">
              消息 <span class="badge">{{notifications.length}}</span>
            </a>
          </li>
          <popover trigger="hover" placement="bottom" title="系统消息" target="#btn-message">
            <template slot="popover">
              <tabs>
                <tab title="紧急">
                  <div v-if="notifications.length==0" style="padding:10px">
                    您没有任何消息！
                  </div>
                  <div v-else class="list-group">
                    <button :key="index" v-for="(item, index) in notifications" type="button" class="list-group-item">
                      【{{item.ticket.user.profile.name}}】的衣服【{{item.ticketClotheRecord.name}}】【{{item.ticketClotheRecord.id}}】未洗，明天要拿！
                    </button>
                  </div>
                </tab>
                <!-- <tab title="提醒">
                  <p>Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus mollit. Keytar helvetica VHS salvia yr, vero magna velit sapiente labore stumptown. Vegan fanny pack odio cillum wes anderson 8-bit, sustainable jean shorts beard ut DIY ethical culpa terry richardson biodiesel. Art party scenester stumptown, tumblr butcher vero sint qui sapiente accusamus tattooed echo park.</p>
                </tab>
                <tab title="消息">
                  <p>Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney's organic lomo retro fanny pack lo-fi farm-to-table readymade. Messenger bag gentrify pitchfork tattooed craft beer, iphone skateboard locavore carles etsy salvia banksy hoodie helvetica. DIY synth PBR banksy irony. Leggings gentrify squid 8-bit cred pitchfork. Williamsburg banh mi whatever gluten-free, carles pitchfork biodiesel fixie etsy retro mlkshk vice blog. Scenester cred you probably haven't heard of them, vinyl craft beer blog stumptown. Pitchfork sustainable tofu synth chambray yr.</p>
                </tab> -->
              </tabs>
              <!-- tabs-example.vue -->
            </template>
          </popover>
          <dropdown tag="li">
            <a class="dropdown-toggle" role="button">管理员 <span class="caret"></span></a>
            <template slot="dropdown">
              <li><a role="button">修改密码</a></li>
              <li><a role="button">系统设置</a></li>
              <li role="separator" class="divider"></li>
              <li>
                <router-link to="/readme">关于</router-link>
              </li>
              <li role="separator" class="divider"></li>
              <li><a role="button" @click="logout">退出登录</a></li>
            </template>
          </dropdown>
        </navbar-nav>
      </template>
    </navbar>
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import mobile from 'is-mobile'
import * as TYPES from '../store/types'

export default {
  name: 'app',
  data() {
    return {
      searchWidth: '300px',
      searchKey: null,
      routes: [{
        path: '/create-ticket',
        title: '开单'
      }, {
        path: '/vips',
        title: '会员'
      }, {
        path: '/tickets',
        title: '衣单'
      }]
    }
  },
  computed: {
    gAlert() {
      return this.$store.state.system.alert
    },
    isMobile() {
      return mobile()
    },
    notifications() {
      const stateItems = this.$store.state.notify.list.items
      if (stateItems) {
        return stateItems
      }
      return []
    }
  },
  methods: {
    reload() {
      window.location.reload(true)
    },
    go(path) {
      this.$router.push(path)
    },
    onSearchKeyChaged() {
      this.$store.dispatch('DO_GET_USER_SEARCH', this.searchKey)
      this.$router.push('/search')
    },
    logout() {
      localStorage.token = ''
      this.$router.push('/login')
    }
  },
  mounted() {
    if (localStorage.token !== '' && localStorage.token !== null && typeof localStorage.token !== 'undefined') {
      // this.$router.push('/search')
    } else {
      this.$router.push('/login')
    }
    this.$center.onclose(err => {
      console.log(err)
      this.$center.start()
      .then(() => console.log('重新连接MessageCenter成功！'))
      .catch(() => console.log('重新连接MessageCenter失败'))
    })
    // 动态设置背景图的高度为浏览器可视区域高度

    // 首先在Virtual DOM渲染数据时，设置下背景图的高度．
    // this.clientHeight.height = `${document.documentElement.clientHeight}px`
    // 然后监听window的resize事件．在浏览器窗口变化时再设置下背景图高度．
    if (mobile()) {
      console.log('IsMobile')
      return
    }
    this.searchWidth = `${document.documentElement.clientWidth - this.$refs['navLeft'].clientWidth - this.$refs['navRight'].clientWidth - 150}px`
    const that = this
    window.onresize = function temp() {
      that.searchWidth = `${document.documentElement.clientWidth - that.$refs['navLeft'].clientWidth - that.$refs['navRight'].clientWidth - 150}px`
    }
    this.$store.dispatch(TYPES.DO_GET_NOTIFICATIONS)
    .then(res => [

    ])
    .catch(res => {

    })
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/NavApp.vue